import { render, staticRenderFns } from "./MobileItemDetails.vue?vue&type=template&id=5ba9cdfe&scoped=true&lang=pug&"
import script from "./MobileItemDetails.vue?vue&type=script&lang=js&"
export * from "./MobileItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./MobileItemDetails.vue?vue&type=style&index=0&id=5ba9cdfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba9cdfe",
  null
  
)

component.options.__file = "MobileItemDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VFlex,
  VIcon,
  VLayout,
})
